import React from "react";
import { TfiReload } from "react-icons/tfi";

function OrderCard({ imageSrc, name, price, date, description,onClick }) {
  console.log("🚀 ~ OrderCard ~ price:", price)
  return (
    <div className="flex flex-col px-4 py-4 mx-auto rounded-3xl shadow-lg bg-[#F8F8F8] border border-gray-200 w-full max-w-[300px]">
      <img src={imageSrc} alt={name} className="w-full rounded-xl aspect-[1.35]" />
      <div className="mt-4 flex justify-between items-center">
        <h2 className="text-base font-bold body text-zinc-800 truncate">{name}</h2>
        <p className="text-base font-bold body text-[#C97C2A]">{price}</p>
      </div>
      <p className="mt-2 text-sm text-gray-600 body line-clamp-2">{description}</p>
      <div className="flex justify-between items-center mt-4">
        <button className="text-xs text-[#C97C2A] body shadow px-3 py-1 rounded-md bg-white cursor-default">
          {date}
        </button>
        <div onClick={onClick} className="bg-[#AF313D] w-8 h-8 flex justify-center items-center rounded-full">
          <TfiReload color="white" className="text-base" />
        </div>
      </div>
    </div>
  );
}

export default OrderCard;
